import { SHOW_FLASH_MESSAGE, HIDE_FLASH_MESSAGE } from '../actions/ui';

const initialState = {
  flashMessage: {
    message: null,
    options: {},
  },
};

// eslint-disable-next-line default-param-last
function uiReducer(state = initialState, action) {
  switch (action.type) {
    case SHOW_FLASH_MESSAGE:
      return {
        flashMessage: {
          message: action.payload,
          options: action.meta,
        },
      };

    case HIDE_FLASH_MESSAGE:
      return initialState;

    default:
      return state;
  }
}

export default uiReducer;
